export const getProductPlanId = (productPlanKey: string, productPlanPeriod: string): string =>
  `${productPlanKey}_${productPlanPeriod}`
